// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info{
    color: #4B2D10;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

.user-info__name{
    display: flex;
    gap: 10px;
    align-items: center;
    text-decoration: none;
    color: #4B2D10;
}

.user-info__img {
    width: 100px; 
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .user-info__img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

.user-info__city{
   color: #BB8D6C;
   font-size: 16px;
}

.user-info__about-me{
    padding: 11px 18px;
    background-color: var(--light-yellow-color);
    border-radius: 16px;
}

.user-info__about-me_title{
    font-weight: bold;
    font-size: 16px;
}

.user-info__about-me_description{
    margin-top: 4px;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/ProfileInfo/ProfileInfo.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;AAEF;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB","sourcesContent":[".user-info{\n    color: #4B2D10;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n}\n\n.user-info__name{\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    text-decoration: none;\n    color: #4B2D10;\n}\n\n.user-info__img {\n    width: 100px; \n    height: 100px;\n    border-radius: 50%;\n    overflow: hidden;\n  }\n  \n  .user-info__img img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n.user-info__city{\n   color: #BB8D6C;\n   font-size: 16px;\n}\n\n.user-info__about-me{\n    padding: 11px 18px;\n    background-color: var(--light-yellow-color);\n    border-radius: 16px;\n}\n\n.user-info__about-me_title{\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.user-info__about-me_description{\n    margin-top: 4px;\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
